import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Stack,
  Typography,
} from "@mui/material";
import React, { useContext, useState } from "react";
import useFetch from "src/Components/Common/useFetch";
import { UseCaseType } from "src/entity/recon-entity/ReconInterfaces";
import { BcPortalContext } from "../../../BalanceConfirmationPortal/BalanceConfirmationPortalContext";
import { ContactDetailsData } from "../../../Common/SubmitContactDetailsDialog";
import { NdButton, NdTextField, validateEmail, validatePhoneNumber } from "../../../MsmePartnerPortal/CommonComponents";
import { BackdropLoader } from "../../../MsmePartnerPortal/PartnerPortal.common";
import $ from "../../../MsmePartnerPortal/PartnerPortal.module.scss";
import BcNewContext from "../BcNewContext";

const UpdateResponseStep3 = ({ open, setOpen, balanceConfirmation, afterSubmitAction }) => {
  const { confirmStatus, setPageStatus, customization } = useContext(BcPortalContext);
  const { companyId, branchCode, currentRow } = useContext(BcNewContext);

  const [data, setData] = useState<ContactDetailsData>({
    designation: "",
    email: "",
    personName: "",
  });
  const [optionalData, setOptionalData] = useState<Pick<ContactDetailsData, "phoneNumber">>({
    phoneNumber: "",
  });

  // const [notFilled, setNotFilled] = useState<boolean>(true);
  // const [checkboxTicked, setCheckboxTicked] = useState(false);

  const [openBackDrop, setOpenBackDrop] = useState<boolean>(false);

  const submitData = async () => {
    setOpenBackDrop(true);
    await submitAction();
    await afterSubmitAction({ ...data, ...optionalData });
    setOpenBackDrop(false);
  };

  const submitAction = async () => {
    return useFetch("/api/PartnerCommunicationPortal/ConfirmFinalSubmissionFromTool", "POST", {
      failureMessage: "Failed to submit response",
      data: {
        businessPartnerId: currentRow?.businessPartnerId,
        mappingId: currentRow?.mappingId,
        communicationId: currentRow?.newMailInitiationCount,
        useCaseType: UseCaseType.balanceConfirmationBeta,
        isBalanceConfirmed: confirmStatus,
        personName: data.personName,
        designation: data.designation,
        email: data.email,
        phoneNumber: optionalData.phoneNumber,
        isLedgerRequest: !balanceConfirmation,
        isPartnerBalanceAsked: customization?.ledgerRequest?.isPartnerBalanceHidden === false,
        companyId: companyId,
        branchCode: branchCode,
      },
      thenCallBack: (res) => {
        if (res.data) {
          setOpen(false);
          setPageStatus("NotFilled");
          afterSubmitAction({ ...data, ...optionalData });
        }
      },
    });
  };

  return (
    <>
      <Dialog open={open} onClose={() => setOpen(false)} classes={{ paper: $.BR_fix }} maxWidth="md" fullWidth>
        <DialogTitle>Update Response - Optional(Step: 3/3)</DialogTitle>
        <DialogContent className={$.flex_column} sx={{ py: 2, px: 3, gap: 2 }}>
          <Stack gap={3}>
            <Typography variant="body2">Fill in the details of email’s respondent, skip if not present</Typography>

            <Box className="d_flex" flexDirection={"column"} gap={1}>
              <FormControl fullWidth sx={{ gap: 2, flexFlow: "row", "&>div": { width: "50%" } }}>
                <NdTextField
                  label="Full Name"
                  value={data.personName}
                  onChange={(_e) => setData((_d) => ({ ..._d, personName: _e.target.value }))}
                />
                <NdTextField
                  label="Designation"
                  value={data.designation}
                  onChange={(_e) => setData((_d) => ({ ..._d, designation: _e.target.value }))}
                />
              </FormControl>
              <FormControl fullWidth sx={{ gap: 2, flexFlow: "row", "&>div": { width: "50%" } }}>
                <NdTextField
                  label="Email"
                  type="email"
                  value={data.email}
                  onChange={(_e) => setData((_d) => ({ ..._d, email: _e.target.value }))}
                  error={data.email && !validateEmail(data.email)}
                />
                <NdTextField
                  label="Phone Number"
                  type="number"
                  value={optionalData.phoneNumber}
                  onChange={(_e) => setOptionalData((_d) => ({ ..._d, phoneNumber: _e.target.value }))}
                  error={optionalData.phoneNumber && !validatePhoneNumber(optionalData.phoneNumber)}
                />
              </FormControl>
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            className={$.BR_fix}
            onClick={() => {
              setPageStatus("NotFilled");
              setOpen(false);
            }}
            color="inherit"
          >
            Cancel
          </Button>
          <NdButton onClick={submitData} autoFocus variant="contained">
            Submit
          </NdButton>
        </DialogActions>
      </Dialog>
      <BackdropLoader openBackDrop={openBackDrop} loadingText={"Saving Details..."} />
    </>
  );
};

export default UpdateResponseStep3;
